import { useEffect, useRef } from "react";
import { GOOGLE_API_KEY } from "../../../../config";
import { observer } from "mobx-react";
import { useStores } from "../../../shared/stores/RootStore";
import { useJsApiLoader } from "@react-google-maps/api";

const StreetViewComponentBase = () => {
  const { mapStore, streetViewStore } = useStores();
  const streetViewRef = useRef(null);

  const { isLoaded: scriptLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_API_KEY,
  });

  useEffect(() => {
    if (scriptLoaded && streetViewRef.current) {
      streetViewStore.init(streetViewRef.current);
    }
    // eslint-disable-next-line
  }, [scriptLoaded]);

  useEffect(() => {
    return () => {
      streetViewStore.resetState();
      mapStore.streetViewMapSource?.update({
        position: undefined,
      });
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div
      ref={streetViewRef}
      style={{ width: "100%", height: "100%", minHeight: "400px" }}
    />
  );
};

export const StreetViewComponent = observer(StreetViewComponentBase);
